/* eslint-disable */
const hash = {
  "en-US": "b7c8c2de",
  "de-DE": "dc54a98c",
  "es-ES": "bfc19215",
  "fr-FR": "abc0942c",
  "id-ID": "22b16ecd",
  "it-IT": "b161f7d0",
  "jp-JP": "503a2c8a",
  "ko-KO": "dffd1bef",
  "nl-NL": "72dd82d2",
  "pl-PL": "20ed23ec",
  "pt-PT": "b03acc97",
  "ru-RU": "76f2a8c2",
  "sv-SE": "8c8ddb87",
  "tr-TR": "ef6f52fe",
  "vi-VN": "f5759bc8",
  "zh-CN": "0b87f3d0",
  "zh-TW": "ecf5c8de",
  "avatars": "bace52d2",
  "control": "c8d53356",
  "plan-details": "81948983",
  "gov-EN": "9ad131e0",
  "en-GB": "60a05fe7"
}
export default hash
